import React, { useRef, useState } from "react";
import styles from "./Contribution.module.css";

import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { countriesArray } from "../../../components/List";
import { InputMask } from "primereact/inputmask";

import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { GetCompanies } from "../../../store/company-store/company-actions";
import { userActions } from "../../../store/auth-store/auth-slice";
import { getTokenInfo } from "../../../utils/Guard";
import { GetUserById } from "../../../store/auth-store/auth-actions";
import {
  CreateQuote,
  SendQuote,
} from "../../../store/orden-store/orden-actions";

import { GetCourse } from "../../../store/course-store/course-actions";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import { ordenActions } from "../../../store/orden-store/orden-slice";
import Quote from "../../../Templates/Quote";
import { SelectButton } from "primereact/selectbutton";
import ApprovedQuote from "../../../components/approvedQuote/ApprovedQuote";
import Loading from "../../../components/loading/Loading";
import { GetDiscountAvailable, VerifyDiscountCode } from "../../../store/discount-store/discount-actions";
import { uiActions } from "../../../store/ui-slice";

let getDiscount = true;
let inputColor = false;

const Contribution = () => {
  const dispatch = useDispatch();

  const [count, setCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [subTotal, setsubTotal] = useState(0);
  const [discountVal, setDiscount] = useState(0);

  const param = useParams();
  const userInfo = getTokenInfo();
  const stepperRef = useRef(null);

  const [taxReceiptValue, setTaxReceiptValue] = useState(null);
  const [pdf, setPdf] = useState(null);
  const options = ["Si", "No"];

  const quote = useSelector((state) => state.orden.quote);

  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedCharge, setSelectedCharge] = useState({ code: 0, name: "" });
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [countries, setCountries] = useState([]);
  const [companies, setCompanies] = useState([]);

    const [invalidField, setInvalidField] = useState("");

  const company = useSelector((state) => state.company);
  const discount = useSelector((state) => state.discount.discount);
  const course = useSelector((state) => state.course.course);
  const notification = useSelector((state) => state.ui.notification);
  const country = countriesArray;
  const user = useSelector((state) => state.auth.auth);

  const [selectedPaymentMethod, setPaymentMethod] = useState({
    code: 0,
    name: "",
  });
  const [selectedStatusMethod, setSelectedStatus] = useState({
    code: 0,
    name: "",
    color: "",
  });
  const [selectedTipo, setSelecedtipo] = useState({ code: "", name: "" });
  const [discountCode, setDiscountCode] = useState("");

  const [orden, setOrden] = useState({
    course: { id: parseInt(param.courseid) },
    ordenType: { id: 2 },
    paymentMethod: { id: 1 },
    status: { id: 1 },
    amount: 0,
    discountCode: "",
    Category: "",
    taxBill: false,
    RNC: "",
    users: [],
  });

  const [newQuote, setNewQuote] = useState({
    course: { id: parseInt(param.courseid) },
    ordenType: { id: 2 },
    paymentMethod: {
      id: 1,
    },
    status: {
      id: 9,
    },
    amount: course.price,
    discountCode: "",
    category: "",
    quantity: 1,
  });  

  useEffect(() => {
      if (userInfo !== undefined &&
        userInfo !== null &&
        userInfo.UserId !== undefined &&
        userInfo.UserId !== null
        && discountCode !== undefined && discountCode !== null && discountCode !== ""
      ) 
      {
        inputColor = true;
        dispatch(VerifyDiscountCode(userInfo.Email, discountCode, param.courseid));
  
      }
  
    }, [discountCode]);

  
  useEffect(() => {
    if (course && course.id > 0) {
      setsubTotal(count * course.price);
      setTotal(subTotal - discountVal);
    }
  }, [course, count, discountVal, subTotal]);

  useEffect(() => {
    if(notification !== null && notification !== undefined && notification.message === "Ya tienes una cotización para este curso.") {
      setTimeout(() => {
        window.location.href = "/orders";
      }, 3000);
    }
  }
, [notification]);


  useEffect(() => {
    if (getDiscount === true) {
      getDiscount = false;
      dispatch(
        GetDiscountAvailable("capacitaciones@aba.org.do", count, param.courseId)
      );
    }
  }, [count, discount, dispatch, param.courseId]);



  useEffect(() => {
    if (
      userInfo !== null &&
      userInfo !== undefined &&
      userInfo.UserId !== undefined &&
      userInfo.UserId !== null
    ) {
      if (selectedCountry === undefined || selectedCountry === null) {
        const foundCountry = country.find(
          (country) => country.name === user.country
        );

        if (foundCountry !== undefined && foundCountry !== null) {
          const countryWithCode = {
            ...foundCountry,
            code: foundCountry.name,
            flag: foundCountry.abreviatura,
          };
          delete countryWithCode.abreviatura;
          onChangeCountriesHandler("countryid", countryWithCode);
        }
      }

      if (
        selectedCharge.code === 0 &&
        user.charge.id !== 0 &&
        user.charge.id !== null &&
        user.charge.id !== undefined
      ) {
        const chargeWithCode = {
          ...user.charge,
          code: user.charge.id,
        };
        delete chargeWithCode.id;
        onChangeChargesHandler("charge", chargeWithCode);
      }
      if (
        selectedCompany === undefined || selectedCompany === null &&
        user.company.id !== 0 &&
        user.company.id !== null &&
        user.company.id !== undefined
      ) {
        onChangeCompaniesHandler("company", user.company.name);
      }
    }
  }, [userInfo]);

  useEffect(() => {
    if (discount && discount.id > 0 && discount.grupal === true && count >= 3) {
      if (discount.percentage === true) {
        setDiscount(count * course.price * (discount.discountPercentage / 100));
      }
      if (discount.nominal === true) {
        setDiscount(count * discount.discountNominal);
      }
    }
    if (discount && discount.id > 0 && discount.grupal === true && count < 3) {
      setDiscount(0);
    }
    if (discount && discount.id > 0 && discount.grupal === false) {
      if (discount.percentage === true) {
        setDiscount(count * course.price * (discount.discountPercentage / 100));
      }
      if (discount.nominal === true) {
        setDiscount(count * discount.discountNominal);
      }
    }
  }, [course.price, count, discount, total]);

  const reportTemplateRef = useRef(null);

  useEffect(() => {
    if (
      quote !== undefined &&
      quote.orderNumber !== undefined &&
      quote.orderNumber > 0 &&
      pdf === null
      // && visibleQuote === true
    ) {
      handleGeneratePdf();
    }
    if (
      pdf !== null &&
      quote !== undefined &&
      quote.orderNumber !== undefined &&
      quote.orderNumber > 0
    ) {
      dispatch(SendQuote(quote, pdf.output("blob"), "aulaaba.aba.org.do"));
      dispatch(ordenActions.setQuote({}));
    }
  }, [
    dispatch,
    param.courseId,
    pdf,
    quote,
    // visibleQuote,
  ]);

  useEffect(() => {
    if (notification !== null && notification !== undefined && notification.message === "Curso no encontrado.") {
      window.location.href = "/courses/none";
    }
  }, [notification]);

  useEffect(() => {
    if (course.id === null || course.id === undefined || course.id === 0) {
      if (
        userInfo !== undefined &&
        userInfo !== null &&
        param.courseid !== undefined &&
        userInfo.email !== undefined &&
        userInfo.email !== null
      ) {
        dispatch(GetCourse(param.courseid, userInfo.email));
      } else if (param.courseid !== undefined) {
        dispatch(GetCourse(param.courseid, 0, "aulaaba.aba.org.do"));
      }
    }
  }, [course.id, param.courseid, dispatch]);

  useEffect(() => {
    if (
      (userInfo !== undefined &&
        userInfo !== null &&
        userInfo.UserId !== undefined &&
        userInfo.UserId !== null &&
        user.name === "") ||
      user.length === 0
    ) {
      dispatch(GetUserById(userInfo.UserId, userInfo.Email, null, true));
    }
  }, [dispatch, user.name]);

  useEffect(() => {
    if (company.companies === undefined || company.companies.length === 0) {
      dispatch(GetCompanies("capacitaciones@aba.org.do"));
    }
  }, [company.companies, dispatch]);

  useEffect(() => {
    if (country !== undefined && country.length > 0) {
      var id = 0;
      const listCountries = country.map((country) => {
        id++;
        return {
          code: country.name,
          name: country.name,
          flag: country.abreviatura,
        };
      });
      setCountries(listCountries);
    }
  }, [country]);

  const onChangeOrdenHandler = (id, value) => {
    let newOrden = { ...orden };
    if (id === "paymentMethod") {
      newOrden.paymentMethod.id = value.code;
      setPaymentMethod(value);
    }
    if (id === "status") {
      newOrden.status.id = value.code;
      setSelectedStatus(value);
    }
    if (id === "type") {
      newOrden.Category = value.code;
      setSelecedtipo(value);
    }
    if (id === "discountCode") {
      newOrden.discountCode = value;
      setDiscountCode(value);
    }
    if (id === "users") {
      newOrden.users.push(value);
    }
    if (id === "taxBill") {
      newOrden.taxBill = value;
    }
    if (id === "rnc") {
      newOrden.RNC = value;
    }

    newOrden.amount = course.price;
    newOrden.course = course;
    setOrden(newOrden);
  };

  const onChangeQuoteHandler = (id, value) => {
    let quote = { ...newQuote };
    quote.paymentMethod.id = 1;
    quote.status.id = 9;
    quote.amount = course.price;

    if (id === "discountCode") {
      quote.discountCode = value;
    }
    if (id === "quantity") {
      quote.quantity = value;
      if (value === 1) {
        quote.category = "individual";
      } else if (value > 1) {
        quote.category = "grupal";
      }
    }

    setNewQuote(quote);
  };

  const handleGeneratePdf = async () => {
    const options = {
      method: "open",
      resolution: Resolution.LOW,
      page: {
        margin: Margin.SMALL,
        format: "a4",
      },
      canvas: {
        mimeType: "image/png",
        qualityRatio: 1,
      },
      overrides: {
        pdf: {
          compress: true,
        },
        canvas: {
          useCORS: true,
        },
      },
    };
    const quotePdf = await generatePDF(reportTemplateRef, options);

    setPdf(quotePdf);
    stepperRef.current.nextCallback();
  };

  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <img
            alt={option.name}
            src={`https://flagcdn.com/48x36/${option.flag.toLowerCase()}.png`}
            style={{ width: "18px" }}
          />
          <div style={{ marginLeft: "5%" }}>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const onCreateQuoteHandler = () => {
    if (taxReceiptValue !== "Si" && taxReceiptValue !== "No") {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error",
          message: "Debe indicar si desea comprobante fiscal",
        })
      );
      return;
    }
    setInvalidField("");

    if (user.name === "") {
      dispatch(
        uiActions.showNotification({
          message: "El nombre es requerido",
          status: "warning",
        })
      );
      setInvalidField("name");
      return;
    } else if (user.email === "") {
      dispatch(
        uiActions.showNotification({
          message: "El email es requerido",
          status: "warning",
        })
      );
      setInvalidField("email");
      return;
    } else if (user.lastName === "") {
      dispatch(
        uiActions.showNotification({
          message: "El apellido es requerido",
          status: "warning",
        })
      );
      setInvalidField("lastName");
      return;
    }
    else if (user.cellPhone === "") {
      dispatch(
        uiActions.showNotification({
          message: "El teléfono es requerido",
          status: "warning",
        })
      );
      setInvalidField("cellPhone");
      return;
    }
    else if (!selectedCountry) {
      dispatch(
        uiActions.showNotification({
          message: "El país es requerido",
          status: "warning",
        })
      );
      setInvalidField("country");
      return;
    }
    else if (!selectedCompany) {
      dispatch(
        uiActions.showNotification({
          message: "La empresa es requerida",
          status: "warning",
        })
      );
      setInvalidField("company");
      return;
    }
     else if (taxReceiptValue !== "Si" && taxReceiptValue !== "No") {
      dispatch(
        uiActions.showNotification({
          message: "Debe indicar si desea comprobante fiscal",
          status: "warning",
        })
      );
      return;
    }
    else if (taxReceiptValue === "Si" && orden.RNC === "") {
      dispatch(
        uiActions.showNotification({
          message: "El RNC es requerido",
          status: "warning",
        })
      );
      setInvalidField("rnc");
      return;
    }

    else if (
      newQuote.quantity === "" ||
      newQuote.quantity === undefined ||
      newQuote.quantity === null
    ) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error",
          message: "El campo cantidad de personas es requerido",
        })
      );
      setInvalidField("peopleAmount");
      return;
    }
    dispatch(
      ordenActions.setOrden({
        orden: {},
      })
    );
    var compa = {};
    if (
      selectedCompany !== null &&
      selectedCompany !== undefined &&
      selectedCompany.code !== undefined
    ) {
      compa = { ...selectedCompany };
    } else {
      compa = {
        code: 0,
        name: selectedCompany,
      };
    }

    const q = {
      user: {
        Id: user.id,
        Name: user.name,
        LastName: user.lastName,
        Email: user.email,
        CellPhone: user.cellPhone,
        Country: selectedCountry.name,
        company: {
          id: user.company.id,
          name: user.company.name,
        },
      },
      course: course,
      quantity: newQuote.quantity,
      discountCode: discount.isValid ? orden.discountCode : "",
      rnc: orden.RNC,
      orderNumber: 0,
      taxBill: taxReceiptValue === "Si" ? true : false,
    };

    dispatch(CreateQuote(q, user.email));
  };

  const onChangeCountriesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.code }));
    setSelectedCountry({
      code: value.code,
      name: value.name,
      flag: value.flag,
    });
  };

  const onChangeCompaniesHandler = (id, value) => {
    if (value.name !== undefined && value.name !== "" && value.name !== null) {
      dispatch(
        userActions.modifyPropertyValue({
          id,
          value: {
            id: value.code,
            name: value.name,
          },
        })
      );
      setSelectedCompany(value.name);
    } else {
      dispatch(
        userActions.modifyPropertyValue({
          id,
          value: {
            id: 0,
            name: value,
          },
        })
      );
      setSelectedCompany(value);
    }
  };


  useEffect(() => {
    if (company.companies !== undefined && company.companies.length > 0) {
      const listCompanies = company.companies.map((company) => {
        return {
          code: company.id,
          name: company.name,
          rnc: company.rnc,
        };
      });

      setCompanies(listCompanies);
    }
  }, [company.companies]);

  const countryOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center" style={{ width: "100px" }}>
        <img
          alt={option.name}
          src={`https://flagcdn.com/48x36/${option.flag.toLowerCase()}.png`}
          style={{ width: "18px" }}
        />
        <div style={{ marginLeft: "5%" }}>{option.name}</div>
      </div>
    );
  };


  

  useEffect(() => {
    if (
      userInfo !== null &&
      userInfo !== undefined &&
      userInfo.UserId !== undefined &&
      userInfo.UserId !== null
    ) {
      if (selectedCountry === undefined || selectedCountry === null) {
        const foundCountry = country.find(
          (country) => country.name === user.country
        );

        if (foundCountry !== undefined && foundCountry !== null) {
          const countryWithCode = {
            ...foundCountry,
            code: foundCountry.name,
            flag: foundCountry.abreviatura,
          };
          delete countryWithCode.abreviatura;
          onChangeCountriesHandler("countryid", countryWithCode);
        }
      }

      if (
        selectedCharge.code === 0 &&
        user.charge.id !== 0 &&
        user.charge.id !== null &&
        user.charge.id !== undefined
      ) {
        const chargeWithCode = {
          ...user.charge,
          code: user.charge.id,
        };
        delete chargeWithCode.id;
        onChangeChargesHandler("charge", chargeWithCode);
      }
      if (
        selectedCompany !== null &&
        selectedCompany !== undefined &&
        selectedCompany.code === 0 &&
        user.company.id !== 0 &&
        user.company.id !== null &&
        user.company.id !== undefined
      ) {
        onChangeCompaniesHandler("company", user.company);
      }
    }
  }, [userInfo]);

  const onChangeChargesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.code }));
    setSelectedCharge({
      code: value.code,
      name: value.name,
    });
  };

  const onChangeHandler = (id, value) => {
    if (id !== "charge" && id !== "department") {
      dispatch(userActions.modifyPropertyValue({ id, value }));
      if (value !== "") {
        dispatch(userActions.setFieldValid({ id, value: true }));
      } else {
        dispatch(userActions.setFieldValid({ id, value: false }));
      }
    } else {
      dispatch(userActions.modifyPropertyValue({ id, value: { id: value } }));
    }
  };
  

  return (
    <>
      {countries.length <= 0 && companies.length <= 0 && (
        <>
          <Loading />
        </>
      )}
      {countries.length > 0 && companies.length > 0 && (
        <>
          <div className={styles.contribution}>
            <Stepper ref={stepperRef}>
              <StepperPanel header="Formulario de cotización">
                <h1 className={styles.formTitle}>Formulario de cotización</h1>
                <div className={styles.facturationForm}>
                  {/* <form className={styles.forms}> */}
                  <div className={styles.forms}>
                    <div className={styles.column}>
                      <label htmlFor="nombre">Nombre</label>
                      <InputText
                        defaultValue={user.name}
                        value={user.name}
                        onChange={(e) =>
                          onChangeHandler("name", e.target.value)
                        }
                        type="text"
                        id="name"
                        disabled = {userInfo !== null && userInfo !== undefined && userInfo.UserId !== undefined && userInfo.UserId !== null} 
                        invalid={invalidField === "name"}
                      />
                    </div>
                    <div className={styles.column}>
                      <label htmlFor="apellido">Apellido</label>
                      <InputText
                        defaultValue={user.LastName}
                        value={user.lastName}
                        onChange={(e) =>
                          onChangeHandler("lastName", e.target.value)
                        }
                        type="text"
                        id="lastName"
                        disabled = {userInfo !== null && userInfo !== undefined && userInfo.UserId !== undefined && userInfo.UserId !== null} 
                        invalid={invalidField === "lastName"}
                      />
                    </div>
                    
                    <div className={styles.column}>
                      <label htmlFor="correo">Correo</label>
                      <InputText
                        defaultValue={user.Email}
                        value={user.email}
                        onChange={(e) =>
                          onChangeHandler("email", e.target.value)
                        }
                        type="text"
                        id="email"
                        disabled = {userInfo !== null && userInfo !== undefined && userInfo.UserId !== undefined && userInfo.UserId !== null} 
                        invalid={invalidField === "email"}
                      />
                    </div>
                    <div className={styles.column}>
                      <label htmlFor="telefono">Teléfono</label>
                      <InputMask
                        id="cellPhone"
                        value={user.cellPhone}
                        onChange={(e) => onChangeHandler("cellPhone", e.target.value)}
                        mask="+1999-999-9999"
                        placeholder="+1999-999-9999"
                        invalid={invalidField === "cellPhone"}
                      />
                    </div>
                    <div className={styles.column}>
                      <label htmlFor="pais">País</label>
                      <Dropdown
                        value={selectedCountry}
                        onChange={(e) => {
                          onChangeCountriesHandler("countryid", e.value);
                        }}
                        options={countries}
                        optionLabel="name"
                        placeholder="Seleccionar pais"
                        valueTemplate={selectedCountryTemplate}
                        filter
                        itemTemplate={countryOptionTemplate}
                        className={styles.profileDropdown}
                        invalid={invalidField === "country"}
                      />
                    </div>

                    <div className={styles.column}>
                      <label htmlFor="empresa">Empresa</label>
                      <Dropdown
                        className={styles.companyInput}
                        onChange={(e) =>
                          onChangeCompaniesHandler("company", e.value)
                        }
                        options={companies}
                        optionLabel="name"
                        editable
                        filter
                        placeholder="Seleccionar empresa"
                        value={selectedCompany}
                        invalid={invalidField === "company"}
                        // type="text"
                        id="company"
                      />
                    </div>
                    <div className={styles.column}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "1.5%",
                          alignItems: "center",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <div
                          style={{
                            alignSelf: "center",
                            flex: 1,
                            alignContent: "center",
                            textAlign: "center",
                          }}
                        >
                          <label htmlFor="empresa">
                            ¿Desea comprobante fiscal?
                          </label>
                          <SelectButton
                            title="¿Desea comprobante fiscal?"
                            className={styles.selectButton}
                            value={taxReceiptValue}
                            onChange={(e) => setTaxReceiptValue(e.value)}
                            options={options}
                            allowEmpty={false}
                          />
                        </div>
                        {taxReceiptValue === "Si" && (
                          <div
                            style={{
                              alignSelf: "center",
                              flex: 1,
                              alignItems: "center",
                            }}
                          >
                            <label htmlFor="rnc">RNC</label>
                            <InputText
                              onChange={(e) =>
                                onChangeOrdenHandler("rnc", e.target.value)
                              }
                              defaultValue={orden.RNC}
                              value={orden.RNC}
                              type="text"
                              id="rnc"
                              className={styles.columnInput}
                              invalid={invalidField === "rnc"}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <div className={styles.column}>
                      <label htmlFor="peopleAmount">Cantidad de personas</label>
                      <InputText
                        type="number"
                        id="peopleAmount"
                        value={newQuote.quantity}
                        onChange={(e) =>
                          onChangeQuoteHandler("quantity", e.target.value)
                        }
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/\D/g, "");
                        }}
                        invalid={invalidField === "peopleAmount"}
                        min={1}
                      />
                    </div>
                    <div className={styles.column}>
                    <label style={{"color" : discount.isValid || inputColor == false ? "#213765" : "#C00000"}} htmlFor="discountCode">Código de descuento {discount.isValid && inputColor == true ? "(Código Válido)": ""} {discount.isValid == false && inputColor == true ? "(Código Inválido)": ""}</label>
                      <InputText
                        type="text"
                        id="discountCode"
                        onChange={(e) =>
                          onChangeOrdenHandler("discountCode", e.target.value)
                        }
                        value={
                          orden.discountCode !== undefined &&
                            orden.discountCode !== ""
                            ? orden.discountCode
                            : discountCode
                        }
                        invalid = {discount.isValid || inputColor == false ? false : true}

                      />
                    </div>
                    <div className={styles.column}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "1.5%",
                        }}
                      >
                        <Button
                          className={styles.saveButton}
                          label="Continuar"
                          // type="submit"
                          onClick={onCreateQuoteHandler}
                        />
                      </div>
                    </div>
                  </div>
                  {/* </form> */}
                </div>
              </StepperPanel>
              <StepperPanel header="Formulario enviado">
                <ApprovedQuote
                  title="Cotización realizada exitosamente"
                  description="Te enviamos un correo electrónico con la cotización."
                  buttonLabel="Volver al inicio"
                  buttonLink="/"
                />
              </StepperPanel>
            </Stepper>
          </div>

          <div ref={reportTemplateRef}>
            <Quote quote={quote} />
          </div>
        </>
      )}
    </>
  );
};

export default Contribution;
